import { faCheckCircle, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomSheet from "components/reusable/BottomSheet";
import { Button } from "flowbite-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGet, apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function AddWalletBottomSheet({ onCreate, onClose }) {
  const { t } = useTranslation();
  const [currencies, setCurrencies] = useState([]);
  const [showSelectCurrenciesSheet, setShowSelectCurrenciesSheet] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [description, setDescription] = useState("");

  const getCurrencies = async () => {
    try {
      const path = pathObj.getCurrencies;
      const result = await apiGet(path);
      setCurrencies(result.data.results);
      setSelectedCurrency(result.data.results[0]);
    } catch (error) {
    }
  };

  useEffect(() => {
    getCurrencies()
  }, [])

  const addWalletSubmit = async () => {
    if (!description || !selectedCurrency) return;

    try {
      const path = pathObj.addWallet;
      const result = await apiPost(path, { currencyId: selectedCurrency._id, description });
      if (result.status === 200) {
        onCreate();
      }
    } catch (err) {}
  };

  return (
    <>
      <BottomSheet
        open={true}
        onClose={onClose}
        title={t("ADD_WALLET")}
      >
        <span className="font-medium text-base">{t("CURRENCY")}</span>
        <div
          className="bg-card text-white flex justify-between items-center p-3 rounded-lg my-3 cursor-pointer"
          onClick={() => {
            setShowSelectCurrenciesSheet(true);
          }}
        >
          <span className="font-medium text-lg">{selectedCurrency?.description || "-"}</span>
          <FontAwesomeIcon icon={faChevronDown} className="card-icon" />
        </div>
        <span className="font-medium text-base">{t("DESCRIPTION")}</span> <br />
        <input
          type="text"
          onChange={(e) => {
            setDescription(e.target.value);
          }}
          className="bg-transparent border border-[var(--card-color)] w-full mt-3 p-2 rounded-lg"
        />
        <div className="flex items-center justify-center mt-3 w-full">
          <Button className="bg-primary py-3 px-10 rounded-lg" onClick={addWalletSubmit}>
            <span className="text-base font-medium text-white">{t("CONFIRM")}</span>
          </Button>
        </div>
      </BottomSheet>

      {showSelectCurrenciesSheet && (
        <BottomSheet
          open={showSelectCurrenciesSheet}
          onClose={() => {
            setShowSelectCurrenciesSheet(false);
          }}
          title={t("SELECT_CURRENCY")}
        >
          {currencies.map((it) => (
            <>
              <div
                className="bg-card p-4 flex justify-start items-center gap-3 mb-3 cursor-pointer text-white"
                onClick={() => {
                  setSelectedCurrency(it);
                  setShowSelectCurrenciesSheet(false);
                }}
              >
                {selectedCurrency === it ? <FontAwesomeIcon icon={faCheckCircle} size="xl" className="card-icon" /> : <></>}
                <span className="font-medium text-lg">{it.description}</span>
              </div>
            </>
          ))}
        </BottomSheet>
      )}
    </>
  );
}

export default AddWalletBottomSheet;
